<template>
  <div class="aiTemplate">
    <DetailsNav></DetailsNav>
    <!-- header -->
    <div class="banner">
      <div
        class="banerCont"
        v-if="bannerInfo"
        :style="{
          'background-color': bannerInfo.bannerColor,
          'background-image': `url(${bannerInfo.bannerBgImg})`,
        }"
      >
        <div class="cont">
          <div class="leftCont">
            <div
              class="logo"
              v-if="bannerInfo.logo && bannerInfo.logo.length > 0"
            >
              <img :src="bannerInfo.logo[0].url" height="121px" alt="" />
            </div>
            <div v-else>
              <div class="title">
                <div class="colFont">{{ bannerInfo.objectName }}</div>
              </div>
              <div class="subTitle">
                <div class="colFont">{{ bannerInfo.objectSubtitle }}</div>
              </div>
            </div>
            <div class="desc">
              <banner-desc
                :data="strToArr(bannerInfo.objectIntroduction)"
              ></banner-desc>
            </div>
            <div class="platfromList">
              <div
                class="platfromPath"

              >   
                <a :href="bannerInfo.funDemonstration" target="_blank">功能演示</a>
              </div>
              <!-- <div
                class="platfromPath file"
              >
              <a :href="bannerInfo.technicalFile" target="_blank">
                技术文档
              </a>
              </div> -->
            </div>
          </div>
          <div class="rightCont">
            <div class="subjectflowTitle">
              <div class="divNav">
                <span
                  @click="
                    () => {
                      $router.push('/');
                    }
                  "
                  class="spanSubject"
                  >首页 /
                </span>
                <span
                  @click="
                    () => {
                      $router.push(routerLink);
                    }
                  "
                  class="spanSubject"
                  >人工智能</span
                >
                <span class="spanName"> / {{ bannerInfo.objectName }}</span>
              </div>
            </div>
            <div class="videoBox">
              <div class="videoMain">
                <div class="actLab">
                  <span></span><span></span><span></span>
                </div>
                <div v-if="videoUrl" class="play" @click="handleVideo()">
                  <img
                    src="./img/icon_play_real.png"
                    width="45px"
                    height="45px"
                    alt=""
                  />
                  <div class="videoDesc">
                    {{ bannerInfo.videoDesc }}
                  </div>
                </div>
                <img
                  v-if="
                    bannerInfo.videoBackground &&
                    bannerInfo.videoBackground.length > 0
                  "
                  width="574"
                  :src="bannerInfo.videoBackground[0].url"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
    <!-- 导航 -->
      <flow-widget
        :flowData="flowData"
        :baseHeight="baseHeight"
        :localItemIndex="localItemIndex"
        class="web_scroll"
      ></flow-widget>
      <!-- end -->
    <div class="divOffsetParent">
      

      <!-- 项目优势 -->
      <div class="advantage" id="scroll1">
        <div class="scrollCont" :class="{ scroll1Show: scroll1Show }">
          <modelTitl
            v-if="platformInfo"
            :title="advantageModleTitle"
            :subTitle="platformInfo.platSubTitle"
            :enTag="String(platformInfo.platEnTitle).toUpperCase()"
          ></modelTitl>
          <!-- 数量不固定最多6个，所以排列方式也不一样，因此做了判断3、5、6个用一个样式，2、4个用另外一个一样 -->
          <div class="moduleList" :class="advantageList.length===3||advantageList.length===5||advantageList.length===6?'moduleList1':'moduleList2'">
            <ul>
              <li v-for="(item, index) in advantageList" :key="index">
                <div class="iconLeft">
                  <img :src="item.iconImg[0].url" alt="" />
                </div>
                <div class="right">
                  <div class="tit">{{ item.title }}</div>
                  <div class="desc">{{ item.desc }}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- end -->
      <!-- 应用场景 -->
      <div
        class="sceneBox"
        id="scroll2"
        :style="{
          'background-color': sceneBgColor,
          'background-image': `url(${
            sceneBgImg && sceneBgImg.length > 0
              ? sceneBgImg[0].url
              : ''
          })`,
        }"
      >
        <div class="scrollCont" :class="{ scroll2Show: scroll2Show }">
          <modelTitl :title="sceneModleTitle"></modelTitl>
          
          <Platform :platformData="platformData"></Platform>
        </div>
      </div>
      <!-- end -->
      <!-- 功能介绍 -->
      <div class="funIntroduce" id="scroll3">
        <div class="scrollCont" :class="{ scroll3Show: scroll3Show }">
          <modelTitl
            v-if="platformInfo"
            :title="funIntroductionTitle"
            :subTitle="platformInfo.platSubTitle"
            :enTag="String(platformInfo.platEnTitle).toUpperCase()"
          ></modelTitl>
          <!-- 数量不固定最多6个，所以排列方式也不一样，因此做了判断3、5、6个用一个样式，2、4个用另外一个一样 -->
          <div class="moduleList" :class="funIntroductionList.length===3||funIntroductionList.length===5||funIntroductionList.length===6?'moduleList1':'moduleList2'">
            <ul>
              <li v-for="(item, index) in funIntroductionList" :key="index">
                <div class="iconLeft">
                  <img :src="item.iconImg[0].url" alt="" />
                </div>
                <div class="right">
                  <div class="tit">{{ item.title }}</div>
                  <div class="desc">{{ item.desc }}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- end -->
      <!-- 技术架构 - start -->
      <div class="modelFeatures" id="scroll4" v-if="modelData">
        <div
          class="modelCont"
          v-for="(item, index) in modelData"
          :key="index + 999"
          :style="{
            'background-color': item.bgColor,
            'background-image': `url(${
              item.bgImg.length > 0 ? item.bgImg[0].url : ''
            })`,
          }"
        >
          <div
            class="modelItem scrollCont"
            :class="{
              scroll4Show: scroll4Show,
            }"
          >
            <modelTitl
              :title="item.title"
              :subTitle="item.subTitle"
              :enTag="String(item.url).toUpperCase()"
            ></modelTitl>
            <div class="bigImgCont">
              <img :src="item.file && item.file[0].url" width="100%" alt="" />
            </div>
          </div>
        </div>
      </div>
      <!-- 技术架构 - end -->
      <!-- 课程大纲 - start -->
      <div class="classList" id="scroll5">
        <div class="scrollCont" :class="{ scroll5Show: scroll5Show }">
          <modelTitl
            v-if="classInfo"
            :title="classInfo.classTitle"
            subTitle=""
            :enTag="classInfo.classEnTitle"
          ></modelTitl>
          <study-path-widge :data="classData"></study-path-widge>
        </div>
      </div>
      <!-- 课程大纲 - end -->
      <!-- 讲师风采 - start -->
      <div
        class="teacherCont"
        id="scroll6"
        v-if="teacherInfo && teacherList"
        :style="{
          'background-color': teacherInfo.teachBgColor,
          'background-image': `url(${
            teacherInfo.teachBgImg && teacherInfo.teachBgImg.length > 0
              ? teacherInfo.teachBgImg[0].url
              : ''
          })`,
        }"
      >
        <div class="scrollCont" :class="{ scroll6Show: scroll6Show }">
          <modelTitl
            :title="teacherInfo.teachModleTitle"
            subTitle=""
            :enTag="teacherInfo.TeachEnTitle"
          ></modelTitl>
          <common-techer-display-widge
            :imgs="teacherList"
            v-if="teacherList.length > 0"
          ></common-techer-display-widge>
        </div>
      </div>
    </div>
    <!-- 讲师风采 - end -->
    <bottom-widge></bottom-widge>
    <MenuAdd ref="editMenu"></MenuAdd>
  </div>
</template>
<script>
import { pythonObject } from '../../../../gqlapi/AiDetail.js';
import DetailsNav from './../../../components/detailsNav.vue';
import bannerDesc from './../../../components/bannerDesc.vue';
import Platform from './components/Platform.vue';
import studyPathWidge from './components/javaStudyPathWidge.vue';
import commonTecherDisplayWidge from './components/techerDisplayWidge';
import modelTitl from './components/modelTitle.vue';
import bottomWidge from './../../../components/bottomWidge';
import MenuAdd from './../../../components/video';
import flowWidget from './components/menuNav.vue';
export default {
  components: {
    bannerDesc,
    DetailsNav,
    bottomWidge,
    Platform,
    modelTitl,
    studyPathWidge,
    commonTecherDisplayWidge,
    MenuAdd,
    flowWidget,
  },
  data() {
    return {
      topImg: '',
      butImg: '',
      showRwm: 99,
      bannerDeSt: false,
      platIsOpen: true,
      baseData: null,
      bannerInfo: null,
      platformInfo: null,
      platformData: null,
      sceneInfo: null,
      sceneBgColor:null,
      sceneBgImg:null,
      modelData: [], // 功能模块、技术架构
      programData: null, // 解决方案
      classData: null, // 课程大纲
      teacherInfo: null,
      teacherList: null, //讲师列表
      classInfo: null,
      programState: 0,
      scrollState: 'add',
      videoUrl: '',
      acttionInfo: null,
      topImgSt: true,
      objName: '',
      routerLink: '',
      scroll1Show:false,
      scroll2Show: false,
      scroll3Show: false,
      scroll4Show: false,
      scroll5Show: false,
      scroll6Show: false,
      bannerLabItems: [],
      advantageModleTitle: '', //项目优势
      advantageList: [], //项目优势列表
      funIntroductionTitle: '', //功能介绍
      funIntroductionList: [], //功能介绍列表
      sceneModleTitle: '', //应用场景
      flowData: [
        { index: 0, desc: '项目优势' },
        { index: 1, desc: '应用场景' },
        { index: 2, desc: '功能介绍' },
        { index: 3, desc: '技术架构' },
        { index: 4, desc: '课程大纲' },
        { index: 5, desc: '研发团队' },
      ],
      baseHeight: 1000,
      localItemIndex: 0,
    };
  },
  computed: {
    programCroll: function () {
      return {
        width: this.programData.AboutImage.length * 1180 + 'px',
        left: -this.programState * 1180 + 'px',
      };
    },
  },
  created() {
    this.getData();
    window.addEventListener('scroll', this.scrollMoveHandle);
    const st = window.localStorage.getItem('topImgSt');
    if (st == undefined || st == null || st == 'show') {
      window.localStorage.setItem('topImgSt', 'show');
      this.topImgSt = true;
    } else {
      this.topImgSt = false;
    }
    this.objName = '品达物流';
    this.routerLink = '/ai';
  },
  methods: {
    getData() {
      this.$axios
        .post('/api', {
          operationName: 'pythonObject',
          variables: {
            id: sessionStorage.getItem('detailsId'),
          },
          query: pythonObject,
        })
        .then((res) => {
          const data = (this.baseData = res.data.data.pythonObject);
          console.log(data)
          this.getBaseHeight();
          this.bannerInfo = {
            logo: data.logo,
            objectName: data.objectName,
            objectSubtitle: data.objectSubtitle,
            objectIntroduction: data.objectIntroduction,
            bannerColor: data.bannerColor,
            videoBackground: data.videoBackground,
            videoDesc: data.videoDesc,
            bannerBgImg:
              data.bannerImg && data.bannerImg.length > 0
                ? data.bannerImg[0].url
                : '',
            funDemonstration: data.funDemonstration,
            technicalFile: data.technicalFile,
          };
          this.bannerLabItems = data.webbannerItems;
          this.videoUrl = data.videoUrl;
          this.platIsOpen = data.platIsOpen;
          this.advantageModleTitle = data.advantageModleTitle;
          this.advantageList = data.advantageList;
          this.funIntroductionList = data.funIntroductionList; //功能介绍列表
          this.platformInfo = {
            platColor: data.platColor,
            platTitle: data.platTitle,
            platSubTitle: data.platSubTitle,
            platEnTitle: data.platEnTitle,
            playBgImg: data.playBgImg,
          };
          this.platformData = data.sceneList;
          this.modelData = data.modular;
          this.programData = data.program;
          this.classInfo = {
            classTitle: data.ClassTitle,
            classEnTitle: data.ClassEnTitle,
          };
          this.classData = data.ClassList;
          this.teacherInfo = {
            teachModleTitle: data.TeachModleTitle,
            TeachEnTitle: data.TeachEnTitle,
            teachBgColor: data.TeachBgColor,
            teachBgImg: data.TeachBgImg,
          };
          this.teacherList = data.Teacheres;
          this.topImg = data.topImg.length > 0 ? data.topImg[0].url : '';
          this.butImg = data.botImg.length > 0 ? data.botImg[0].url : '';
          this.acttionInfo = {
            actionlabel: data.actionlabel,
            actionImg: data.actionImg,
          };
          //   功能介绍
          this.funIntroductionTitle = data.funIntroductionTitle; //功能介绍
          //   应用场景数据
        //   this.sceneInfo = {
            this.sceneBgColor= data.sceneBgColor
            this.sceneBgImg=data.sceneBgImg
        //   };
          this.sceneModleTitle = data.sceneModleTitle; //应用场景标题
          //   this.scrollHandle()
        });
    },
    getBaseHeight() {
      setTimeout(() => {
        this.baseHeight = document.querySelector('.divOffsetParent').offsetTop;
        console.log(this.baseHeight);
      });
    },
    scrollMoveHandle() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // 显示马上学习导航
      let tag1 = document.querySelector("#scroll1");
      let tag2 = document.querySelector("#scroll2");
      let tag3 = document.querySelector("#scroll3");
      let tag4 = document.querySelector("#scroll4");
      let tag5 = document.querySelector("#scroll5");
      let tag6 = document.querySelector("#scroll6");
      const showNum = 10
       const num = -670
      if (scrollTop >= tag1.offsetTop - showNum) {
        this.scroll1Show = true;
      }
      if (scrollTop >= tag2.offsetTop - showNum) {
        this.scroll2Show = true;
      }
      if (scrollTop >= tag3.offsetTop - showNum) {
        this.scroll3Show = true;
      }
      if (scrollTop >= tag4.offsetTop - showNum) {
        this.scroll4Show = true;
      }
      if (scrollTop >= tag5.offsetTop - showNum) {
        this.scroll5Show = true;
      }
      if (scrollTop >= tag6.offsetTop - showNum) {
        this.scroll6Show = true;
      }
      if (scrollTop >= tag1.offsetTop - num) {
        this.localItemIndex = 0
      }
      if (scrollTop >= tag2.offsetTop - (-600)) {
        this.localItemIndex = 1
      }
      if (scrollTop >= tag3.offsetTop - (-620)) {
        this.localItemIndex = 2
      }
      if (scrollTop >= tag4.offsetTop - (-620)) {
        this.localItemIndex =3
      }
      if (scrollTop >= tag5.offsetTop - (-600)) {
        this.localItemIndex = 4
      }
      if (scrollTop >= tag6.offsetTop - (-580)) {
        this.localItemIndex = 5
      }
    },
    // 鼠标滑过展示二维码
    rwmHover(index) {
      this.showRwm = index;
    },
    //
    goDetailPage(url) {
      if (url && /^http/.test(url)) {
        window.open(url, '_black');
      }
    },
    // 解决方案切换
    checkHandle(ind) {
      this.programState = ind;
    },
    // 解决方案自动滚动
    scrollHandle() {
      if (this.programData) {
        const num = this.programData.AboutImage.length - 1;
        clearInterval(this.timer);
        this.timer = setInterval(() => {
          if (this.programState == num) {
            this.programState = 0;
          } else {
            this.programState++;
          }
        }, 3000);
      }
    },
    stopScroll() {
      clearInterval(this.timer);
    },
    setScroll() {
      this.scrollHandle();
    },
    closeTopImg() {
      window.localStorage.setItem('topImgSt', 'unShow');
      this.topImgSt = false;
    },
    handleVideo() {
      this.$trackEvent('视频介绍', '点击', '前端学科');
      let obj = {
        url: this.videoUrl,
      };
      this.$refs.editMenu.dialogFormV(obj);
    },
  },
  beforeDestroy() {
    this.stopScroll();
    window.removeEventListener('scroll', this.scrollMoveHandle);
  },
};
</script>
<style lang="scss" scoped src="./index.scss"></style>

